import {
    IFormSettings,
    FormSettingsTypes,
    ChangeFormSettingsRequestActionType,
    ChangeFormSettingsSuccessActionType,
    ChangeFormSettingsFailureActionType,
    InitFormSettingsActionType,
    ChangeGeneralSettingActionType,
    ChangeLimitSettingsActionType,
    ChangeNativeFormSettingsRequestActionType,
    ChangeNotificationSettingsActionType,
    ChangeSaveProgressSettingsActionType,
    ChangeConfirmationSettingsActionType,
} from "./types";
import { Handler } from "./../types/store-types";

const changeFormSettingsRequest: Handler<IFormSettings, ChangeFormSettingsRequestActionType> = (state, { payload }) => {
    return { ...state, ...payload };
};

const changeFormSettingsSuccess: Handler<IFormSettings, ChangeFormSettingsSuccessActionType> = state => {
    return { ...state };
};

const changeFormSettingFailure: Handler<IFormSettings, ChangeFormSettingsFailureActionType> = (state, { payload }) => {
    return { ...state, ...payload };
};

const initFormSettings: Handler<IFormSettings, InitFormSettingsActionType> = (state, { payload }) => {
    return { ...state, ...payload };
};

const changeGeneralSetting: Handler<IFormSettings, ChangeGeneralSettingActionType> = (state, { payload }) => {
    return { ...state, general: payload.currentState };
};

const changeLimitsSetting: Handler<IFormSettings, ChangeLimitSettingsActionType> = (state, { payload }) => {
    return { ...state, limits: payload.currentState };
};

const changeNotificationsSetting: Handler<IFormSettings, ChangeNotificationSettingsActionType> = (
    state,
    { payload },
) => {
    return { ...state, notification: payload.currentState };
};

const changeSaveProgressionsSetting: Handler<IFormSettings, ChangeSaveProgressSettingsActionType> = (
    state,
    { payload },
) => {
    return { ...state, saveProgress: payload.currentState };
};

const changeConfirmationionSetting: Handler<IFormSettings, ChangeConfirmationSettingsActionType> = (
    state,
    { payload },
) => {
    return { ...state, confirmation: payload.currentState };
};

const changeNativeSettings: Handler<IFormSettings, ChangeNativeFormSettingsRequestActionType> = (
    state,
    { payload },
) => {
    return { ...state, native: { ...payload.currentState } };
};

export const handlersConfigs = {
    [FormSettingsTypes.INIT_FORM_SETTINGS]: initFormSettings,
    [FormSettingsTypes.CHANGE_FORM_SETTINGS_REQUEST]: changeFormSettingsRequest,
    [FormSettingsTypes.CHANGE_FORM_SETTINGS_SUCCESS]: changeFormSettingsSuccess,
    [FormSettingsTypes.CHANGE_FORM_SETTINGS_FAILURE]: changeFormSettingFailure,
    [FormSettingsTypes.CHANGE_GENERAL_SETTING_REQUEST]: changeGeneralSetting,
    [FormSettingsTypes.CHANGE_LIMITS_SETTING]: changeLimitsSetting,
    [FormSettingsTypes.CHANGE_NOTIFICATIONS_SETTING]: changeNotificationsSetting,
    [FormSettingsTypes.CHANGE_SAVE_PROGRESS_SETTING]: changeSaveProgressionsSetting,
    [FormSettingsTypes.CHANGE_CONFIRMATION_SETTING]: changeConfirmationionSetting,
    [FormSettingsTypes.CHANGE_NATIVE_SETTING_REQUEST]: changeNativeSettings,
};
